import Auth from "../api/auth.js";
import { canAccess } from "./permissions.js";

export function getAccessContext(tokenOverride) {
  const token = tokenOverride || Auth.getToken();
  const valid = Auth.isTokenValid(token);
  const payload = valid ? Auth.getPayload(token) : {};
  const roles = Array.isArray(payload?.roles) ? payload.roles : [];
  const universities = Array.isArray(payload?.universities) ? payload.universities : [];
  return {
    token,
    valid,
    roles,
    universities,
    hasUniversities: universities.length > 0,
  };
}

export function hasToolAccess(permissionKey, context = getAccessContext()) {
  if (!context.valid) return false;
  if (permissionKey !== "supportReview" && !context.hasUniversities) return false;
  return canAccess(context.roles, permissionKey);
}
